import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectAdminToken } from "../admin/sessionSlice";
import { getLobbyGameData } from "../functions/getLobbyGameData";

export function useLobbyWords(lobbyName) {
  const adminToken = useSelector(selectAdminToken);
  const [questions, setQuestions] = useState([]);
  const [timeDurationMin, setTimeDurationMin] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!lobbyName) return undefined;
    let cancelled = false;

    const storedUserData = (() => {
      try {
        return JSON.parse(sessionStorage.getItem("userData") || "{}") || {};
      } catch {
        return {};
      }
    })();

    const uid = storedUserData.userId || storedUserData.userid || storedUserData.id;
    const tokenForApi = (() => {
      const t = adminToken != null ? String(adminToken).trim() : "";
      if (t.includes("&")) return t;
      const sid = storedUserData.sessionId;
      const oid = storedUserData.organizationId;
      return sid && oid ? `${sid}&${oid}` : "";
    })();

    if (!tokenForApi || !uid) {
      setError("Missing session.");
      return undefined;
    }

    setLoading(true);
    setError("");
    (async () => {
      try {
        const gs = (() => {
          try {
            return JSON.parse(sessionStorage.getItem("gameSettings") || "{}") || {};
          } catch {
            return {};
          }
        })();
        const data = await getLobbyGameData({
          token: tokenForApi,
          userId: uid,
          themeName: "guess_me",
          lobby_name: lobbyName,
          ...(gs.lobby_pin ? { lobby_pin: gs.lobby_pin } : {}),
        });
        if (cancelled) return;
        const rows = Array.isArray(data?.questions) ? data.questions : [];
        setQuestions(rows);
        const dur = Number(data?.time_duration);
        setTimeDurationMin(Number.isFinite(dur) && dur > 0 ? dur : Number(gs.time) || 1);
      } catch (e) {
        if (!cancelled) setError(e?.message || "Failed to load words.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [lobbyName, adminToken]);

  return { questions, timeDurationMin, loading, error };
}
